import React from 'react'

const Title = ({ children }: { children: React.ReactNode }) => (
  <div className="font-inter text-center font-medium text-[12px] leading-[17px] text-[#394658]">
    {children}
  </div>
)

export default Title
